import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

type Props = {
    copy: string;
};

export function TranscriptSummaryAiSettings(props: Props) {
    return (
        <div className='flex align-center justify-sb'>
            <Body size='small'>
                {props.copy} {/* @ts-expect-error */}
                <Link as={RoutedLink} to='/setup/ai-features' variant='primary' size='small'>
                    Update settings
                </Link>
            </Body>
        </div>
    );
}
